import { schema } from 'normalizr';

export const currencyListItem = new schema.Entity(
  'currencyList',
  {},
  {
    idAttribute: item => item.name,
    processStrategy: item => ({
      name: item.name,
      code: item.code,
      slug: item.slug,
      type: item.type,
      nameG: item.nameG,
      nameAcc: item.nameAcc,
      group: item.group,
      title: item.title,
    }),
  }
);

export const convertorCurrencyList = [currencyListItem];
